module.exports = __webpack_public_path__ + "media/images/font/Gustavo-MediumItalic-37782b576d3e11ada5760ad229b054fe.ttf";